import { joinPath } from '@eventbrite/path-utils';
import { replace } from 'react-router-redux';
import { Dispatch } from 'redux';
import { BASE_URL, PRE_TICKETS_ORGANIZER_QUESTIONS_PATH } from '../constants';
import { CheckoutState } from '../state';

export const goToPreTicketsQuestionsPage =
    () => async (dispatch: Dispatch<CheckoutState>) =>
        dispatch(
            replace(joinPath(BASE_URL, PRE_TICKETS_ORGANIZER_QUESTIONS_PATH)),
        );
